import { configureStore } from "./reducerManager.js";

import { initState } from "./appReducer";

const storeInitialState = {
  app: initState,
};

let store = configureStore(storeInitialState);

export { store };
